<template>
    <div v-if="purchase">
        <p class="fs-12 m-0 grey-color text-break">
            <span class="mr-2" @click="showModal">
                <img src="/images/edit_icon.svg" alt="check_label" style="width: 16px; cursor: pointer" />
            </span>

            <b>Примечание: </b>
            <template v-if="purchase.comment">
                {{ purchase.comment }}
            </template>
            <template v-else> &mdash; </template>
        </p>
        <b-modal v-model="show" :title="'Редактирование примечания к закупке ' + purchase.reg_number" no-close-on-backdrop no-close-on-esc no-close-on-ok hide-footer @cancel="handleModalCancel" @close="handleModalCancel" @ok="handleModalAccept">
            <b-row class="mb-4">
                <b-col>
                    <form-row-edit-textarea label="Примечание к закупке" v-model="comment" :rows="8" />
                </b-col>
            </b-row>
            <b-row>
                <b-col class="text-right">
                    <b-overlay :show="isDataUpdating" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                        <b-button class="mr-2 text-uppercase" variant="custom-outline-secondary" @click="handleModalCancel">Отмена</b-button>
                    </b-overlay>
                    <b-overlay :show="isDataUpdating" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                        <b-button class="text-uppercase" variant="custom-green" @click="handleModalAccept">Сохранить</b-button>
                    </b-overlay>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'fl223-purchase-comment-edit-block',
    props: {
        purchase: {
            type: Object
        }
    },
    data() {
        return {
            show: false,
            isDataUpdating: false,
            comment: ''
        };
    },
    methods: {
        showModal() {
            this.show = true;
            this.isDataUpdating = false;
            this.comment = this.purchase.comment;
        },
        handleModalCancel() {
            this.comment = null;
            this.show = false;
            this.isDataUpdating = false;
        },
        async handleModalAccept() {
            this.isDataUpdating = true;
            await this.$api.products.fl223.purchases.updateComment(this.purchase.id, this.comment);
            this.show = false;
            this.isDataUpdating = false;
            this.$emit('refresh');
        }
    }
};
</script>
